import { TabPanel, Tabs } from 'tea-component';
import useLanguage from '@op/hooks/useLanguage';
import InsightAnalysis from '../InsightAnalysis';
import React, { useMemo, useState } from 'react';
import { ClassSpecial } from '@op/constants/common';
import CardCommon from '@op/components/CardCommon';
import BubbleCommon from '@op/components/BubbleCommon';
import './index.scss';
import VideoTable from './VideoTable';
import { DefaultImg } from '@op/constants/defaultImg';
import { useFrontWebConfig } from '@op/hooks/useFrontWebConfig';

export default function ExecutionProgress({
  filter,
  videoFilter,
  gameInfo,
  wholeGameInfo,
}: {
  filter: any;
  videoFilter: any;
  gameInfo: any;
  wholeGameInfo: any;
}) {
  const { formatMessage } = useLanguage();
  const HIDE_UGC_VIDEO = useFrontWebConfig({
    keys: 'hide_weekly_report_ugc_video',
  });
  const tabs = useMemo(() => {
    const list: any[] = [
      {
        text: formatMessage('Official Account User Comment Analysis'),
        value: 'official',
        icon: true,
      },
      {
        text: formatMessage('AI Analysis of Hot UGC Content'),
        value: 'ugc_ai',
        icon: true,
      },
    ];

    if (!HIDE_UGC_VIDEO) {
      list.push({
        text: formatMessage('Hot UGC Videos'),
        value: 'ugc_video',
      });
    }

    return list;
  }, [formatMessage]);

  const [clickedTab, setClickedTab] = useState('official');

  return (
    <CardCommon contentCard className={'dbo-ExecutionProgress-cardCommon'}>
      {/* 标题 */}
      <BubbleCommon tipsMap={undefined} showIcon={false} placement="top">
        <div
          style={{ fontSize: '18px', padding: '0px 0px 10px 20px' }}
          className="dbo-community-metrics-title  --link"
        >
          {formatMessage('Insight Analysis')}
        </div>
      </BubbleCommon>

      {/* tab */}
      <div className="dbo-ExecutionProgress-Tab">
        {tabs.map((item) => (
          <div
            key={item.value}
            onClick={() => setClickedTab(item.value)}
            className={`dbo-ExecutionProgress-TabItem ${
              clickedTab === item.value &&
              'dbo-ExecutionProgress-clickedTabItem'
            } `}
          >
            {item.icon && <img src={DefaultImg.AI} />}
            {item.text}
          </div>
        ))}
      </div>
      <Tabs
        activeId={clickedTab}
        className={ClassSpecial.TAB_NONE}
        tabs={tabs.map((item) => ({ label: item.text, id: item.value }))}
      >
        <TabPanel id={'official'}>
          <InsightAnalysis
            filter={filter}
            title={formatMessage('Official Account User Comment Analysis')}
            RichModuleKey="insight"
          />
        </TabPanel>
        <TabPanel id={'ugc_ai'}>
          <InsightAnalysis
            filter={filter}
            title={formatMessage('AI Analysis of Hot UGC Content')}
            summary_type={'ugc_video_summary'}
          />
        </TabPanel>
        <TabPanel id={'ugc_video'}>
          <VideoTable
            filter={videoFilter}
            gameInfo={gameInfo}
            wholeGameInfo={wholeGameInfo}
          ></VideoTable>
        </TabPanel>
      </Tabs>
    </CardCommon>
  );
}
